import { render, staticRenderFns } from "./EntityNumberField.vue?vue&type=template&id=863dbcda&scoped=true&lang=pug&"
import script from "./EntityNumberField.vue?vue&type=script&lang=js&"
export * from "./EntityNumberField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "863dbcda",
  null
  
)

export default component.exports